const model = {
    name: 'FacetSort',
    properties: {
        name: { required: true },
        order: { required: true },
    },
};
export default model;
